import { FLAG_DRC_LOYALTY } from 'common/constants'
import { IconCard } from 'components/Common/IconCard'
import { Image } from 'components/Shared/Image'
import { useFeatureFlag } from 'hooks/useFeatureFlag'
import { useLogger } from 'hooks/useLogger'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

export const DRCLogo = (
  <Image
    image={{
      originalImageUrl:
        'https://info.diningrewardsclub.com/wp-content/uploads/2023/10/DRC-1.png',
      id: 'DRC-logo',
    }}
    width={50}
    height={50}
    alt={'DRC Logo'}
  />
)

export const DRCLoyalty = () => {
  const intl = useIntl()
  const { logEvent } = useLogger()

  const { value: DRCLoyaltyFlagEnabled } = useFeatureFlag(FLAG_DRC_LOYALTY)

  if (!DRCLoyaltyFlagEnabled) {
    return null
  }

  return (
    <div className="space-y-5 px-4 py-5">
      <h3 className="my-heading-sm">
        <FormattedMessage defaultMessage="Your Rewards" id="LVk5j9" />
      </h3>
      <IconCard
        data-testid="drc-loyalty-card"
        heading={intl.formatMessage({
          defaultMessage: 'DRC Members',
          id: 'awM7d2',
        })}
        target="_blank"
        rel="external noreferrer"
        href={`https://diningrewards.com.au/`}
        onClick={() => logEvent(`Clicked DRC Loyalty banner`)}
        description={
          <FormattedMessage
            defaultMessage="View your Cashback balance or sign up for DRC Rewards."
            id="hZJQnk"
          />
        }
        icon={DRCLogo}
      />
    </div>
  )
}
